import type { ColumnType, TransformType } from '../types/template';

export const ERROR_CODES = {
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  INVALID_TEMPLATE: 'INVALID_TEMPLATE',
  MISSING_VERSION: 'MISSING_VERSION',
  MISSING_IMPORTER_CONFIG: 'MISSING_IMPORTER_CONFIG',
  MISSING_IMPORTER_CONFIG_TYPE: 'MISSING_IMPORTER_CONFIG_TYPE',
  MISSING_IMPORTER_CONFIG_TITLE: 'MISSING_IMPORTER_CONFIG_TITLE',
  INVALID_ALLOW_UNMAPPED_COLUMNS: 'INVALID_ALLOW_UNMAPPED_COLUMNS',
  INVALID_LIMITS: 'INVALID_LIMITS',
  INVALID_PARSER_OPTIONS: 'INVALID_PARSER_OPTIONS',
  MISSING_COLUMNS: 'MISSING_COLUMNS',
  MISSING_COLUMN_PROPERTY: 'MISSING_COLUMN_PROPERTY',
  DUPLICATE_COLUMN_KEY: 'DUPLICATE_COLUMN_KEY',
  INVALID_COLUMN_TYPE: 'INVALID_COLUMN_TYPE',
  INVALID_REGEX: 'INVALID_REGEX',
  INVALID_REGEX_MESSAGE: 'INVALID_REGEX_MESSAGE',
  INVALID_TRANSFORM: 'INVALID_TRANSFORM',
  INVALID_OPTIONS: 'INVALID_OPTIONS',
  REGEX_IGNORED_WITH_OPTIONS: 'REGEX_IGNORED_WITH_OPTIONS',
  MISSING_TEMPLATE_URL: 'MISSING_TEMPLATE_URL',
  TEMPLATE_FETCH_ERROR: 'TEMPLATE_FETCH_ERROR',
  TEMPLATE_PARSE_ERROR: 'TEMPLATE_PARSE_ERROR',
  TEMPLATE_TIMEOUT: 'TEMPLATE_TIMEOUT',
  MISSING_IMPORTER_CONFIG_COLUMNS: 'MISSING_IMPORTER_CONFIG_COLUMNS',
  INVALID_UNIQUE: 'INVALID_UNIQUE',
  UNIQUE_WITH_DEFAULT: 'UNIQUE_WITH_DEFAULT',
} as const;

export const DEFAULT_MAX_FILE_SIZE = 10_485_760; // 10 MB
export const DEFAULT_MAX_ROWS = 100_000;
export const DEFAULT_TEMPLATE_TIMEOUT_MS = 10_000;

/**
 * Time in milliseconds before transitioning from the 'processing' view
 * to the 'processing-delay' view during submit. This is the only timeout
 * in the submit flow — there is no hard abort.
 */
export const DEFAULT_PROCESSING_DELAY_MS = 10_000;

/**
 * Minimum time (ms) to show the processing/spinner screen on step transitions.
 * Prevents a jarring flash when the async operation completes near-instantly.
 */
export const MIN_PROCESSING_DISPLAY_MS = 1_000;

/** Protected PapaParse keys that cannot be overridden by host apps */
export const PROTECTED_PAPAPARSE_KEYS = [
  'header',
  'worker',
  'step',
  'complete',
  'error',
  'chunk',
  'beforeFirstChunk',
  'download',
  'preview',
  'transform',
  'transformHeader',
] as const;

export const SUPPORTED_COLUMN_TYPES: ReadonlySet<string> = new Set<ColumnType>([
  'string',
  'number',
  'email',
  'date',
  'boolean',
  'phone',
  'custom',
]);

export const SUPPORTED_TRANSFORMS: ReadonlySet<string> = new Set<TransformType>(
  ['trim', 'uppercase', 'lowercase', 'none'],
);

export const SUPPORTED_DATE_FORMATS: ReadonlySet<string> = new Set([
  'YYYY-MM-DD',
  'MM/DD/YYYY',
  'DD/MM/YYYY',
  'MM-DD-YYYY',
  'DD-MM-YYYY',
]);
